import DemoPage from '@/components/pages/DemoPage.vue';
import { LoginPage, ResetCredentialsPage } from '@authentication/ui/pages';
import { useGlobalConfigStore } from '@shared/stores';
import { AuthenticationLayoutTemplate } from '@shared/ui/templates';
import { createRouter, createWebHistory } from 'vue-router';

const meta: any = import.meta;

const router = createRouter({
  history: createWebHistory(meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: AuthenticationLayoutTemplate,
      children: [
        {
          path: ':realm/protocol/openid-connect/signin',
          component: LoginPage,
        },
        {
          path: ':realm/login-actions/reset-credentials',
          component: ResetCredentialsPage,
        }
      ],
    },
    {
      path: '/demo',
      component: DemoPage
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/default/protocol/openid-connect/signin',
    },
  ],
});

router.beforeEach((to, _from, next) => {
  if (to.matched.some((record) => (record.meta.requiresAllowRegistration))) {
    const { allowRegistration } = useGlobalConfigStore();

    if (!allowRegistration) {
      next('/errors/404');
      return;
    }
  }

  next();
});

export default router;
